import { render, staticRenderFns } from "./noMore.vue?vue&type=template&id=7497272d&scoped=true"
import script from "./noMore.vue?vue&type=script&lang=ts"
export * from "./noMore.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./noMore.vue?vue&type=style&index=0&id=7497272d&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7497272d",
  "07e9c953"
  
)

export default component.exports